import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import StarIcon from '@mui/icons-material/Star';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import Sorting, { useSorting } from 'components/Sorting';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import ServiceRow from 'components/ServiceRow';
import FabDialog from 'components/FabDialog';
import AddServiceDialog from 'components/AddServiceDialog';

import { useDelete } from 'lib';

import { ServiceGroupEditServices_serviceGroup$key } from '__generated__/ServiceGroupEditServices_serviceGroup.graphql';
import { ServiceGroupEditServicesSortMutation } from '__generated__/ServiceGroupEditServicesSortMutation.graphql';

type Props = {
  serviceGroup: ServiceGroupEditServices_serviceGroup$key;
};

const ServiceGroupEditServices: FC<Props> = props => {
  const serviceGroup = useFragment(
    graphql`
      fragment ServiceGroupEditServices_serviceGroup on ServiceGroup {
        services(first: 2147483647) {
          __id
          edges {
            node {
              id

              ...ServiceRow_service
            }
          }

          pageInfo {
            ...Table_pageInfo
          }
        }

        ...AddServiceDialog_serviceGroup
      }
    `,
    props.serviceGroup
  );

  const connectionId = serviceGroup.services?.__id;

  const [sort, sorting] = useSorting<ServiceGroupEditServicesSortMutation>(
    graphql`
      mutation ServiceGroupEditServicesSortMutation(
        $positions: [EntityWithPositionInput!]!
      ) {
        updateServicePositions(positions: $positions)
      }
    `,
    connectionId
  );

  const [deleteService, deleting] = useDelete(connectionId);

  const { edges, pageInfo } = serviceGroup.services ?? {};

  if (!edges) return null;

  return (
    <Paper sx={{ p: 2 }}>
      <Sorting edges={edges} onSort={sort}>
        <Table
          pagination
          pageInfo={pageInfo ?? null}
          icon={<StarIcon />}
          loading={deleting || sorting}
          head={
            <TableRow>
              <TableCell />
              <TableCell>Pavadinimas</TableCell>
              <TableCell center>Kaina/asm</TableCell>
              <TableCell center>Tipas</TableCell>
              <TableCell />
            </TableRow>
          }>
          {edges?.map(({ node }) => (
            <ServiceRow key={node.id} service={node} onDelete={deleteService} />
          ))}
        </Table>
      </Sorting>

      {connectionId && (
        <FabDialog fullWidth maxWidth="sm">
          <AddServiceDialog
            connectionId={connectionId}
            serviceGroup={serviceGroup}
          />
        </FabDialog>
      )}
    </Paper>
  );
};

export default ServiceGroupEditServices;
